export function equipementRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_EQUIPEMENT_START":           
        case "FETCH_EQUIPEMENTS_START":                                 
        case "UPDATE_EQUIPEMENT_START":                                 
        case "DELETE_EQUIPEMENT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_EQUIPEMENT_FULFILLED":           
        case "FETCH_EQUIPEMENTS_FULFILLED":                                 
        case "UPDATE_EQUIPEMENT_FULFILLED":                                 
        case "DELETE_EQUIPEMENT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_EQUIPEMENT_ERROR":
        case "FETCH_EQUIPEMENTS_ERROR":
        case "UPDATE_EQUIPEMENT_ERROR":
        case "DELETE_EQUIPEMENT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}